export default "__VITE_ASSET__CNmPUneA__"